@if (survey && isInitialised) {
    <div class="d-flex flex-column">
        @if (workflowCard) {
            <div class="d-flex flex-column gap-2">
                @if (surveyCompleted) {
                    @if (surveySummaryLink) {
                        <a class="content"
                           [routerLink]="surveySummaryLink.path"
                           [queryParams]="surveySummaryLink.queryParams">View survey summary</a>
                    }
                    <adapt-progress-bar class="content"
                                        [percentageProgress]="participationRate"
                                        [overrideText]="participationText"></adapt-progress-bar>
                    <adapt-workflow-card-action [connection]="workflowConnection">
                        <div>Survey complete, please continue by clicking below</div>
                    </adapt-workflow-card-action>
                } @else {
                    <button class="btn btn-link content"
                            (click)="viewOutstandingResponses()">Manage survey</button>
                    <adapt-progress-bar class="content"
                                        [percentageProgress]="participationRate"
                                        [overrideText]="participationText"></adapt-progress-bar>
                    <adapt-workflow-card-action [connection]="workflowConnection"
                                                [actionText]="surveyLink ? 'Take survey now' : undefined"
                                                [actionIcon]="surveyLink ? 'fas fa-fw fa-arrow-right' : undefined"
                                                [action]="surveyLink ? takeSurvey : undefined">
                        <div>Survey will end {{ survey.endTime | adaptDateTime }}</div>
                    </adapt-workflow-card-action>
                }
            </div>
        } @else {
            @if (surveyCompleted) {
                <p>
                    The survey has been completed.
                    @if (surveySummaryLink) {
                        <span>The result of the survey can be viewed <a [routerLink]="surveySummaryLink.path"
                               [queryParams]="surveySummaryLink.queryParams">here</a></span>
                    }
                    . You are now ready to move on to next step.
                </p>
            } @else {
                @if (outstandingSurveyResponses.length > 0) {
                    @if (surveyLink) {
                        <div class="py-3 mb-3 d-flex flex-column align-items-center alert alert-info">
                            <button class="btn btn-secondary"
                                    adaptButtonIcon="fal fa-clipboard-list-check"
                                    data-test="take-survey-now-button"
                                    (click)="takeSurvey()">Take survey now</button>
                        </div>
                    }
                    <h5>
                        Outstanding responses from the team&nbsp;
                        <span class="fal fa-info-circle"
                              adaptTooltip="Note that {{ projectLabel }} will only track survey responses which have not been submitted. Once a response is submitted, it can no longer be tracked."></span>
                    </h5>
                    <adapt-view-survey-outstanding-responses [ngClass]="(isMobile$ | async) === false ? 'responses' : ''"
                                                             [survey]="survey"
                                                             [showNote]="false"
                                                             [showEmail]="false"></adapt-view-survey-outstanding-responses>
                } @else {
                    <p>All survey responses have been submitted.</p>
                }
            }
        }
    </div>
}
